import React from "react";
import styles from "./ContainerOverlay.module.scss";
const ContainerOverlay = ({ closeMenus, }) => {
    const handleClick = () => {
        closeMenus();
    };
    return (<>
      <div data-testid="content-overlay" className={styles.contentOverlay} onClick={handleClick} onKeyDown={handleClick} role="presentation"/>
      <style>
        {`       
              body {
                  position: fixed;
                  width: 100%;
                  height: 100%;
                  touch-action: none;
                  -webkit-overflow-scrolling: none;
                  overflow: hidden;
                  overscroll-behavior: none;
                }
        `}
      </style>
    </>);
};
export default ContainerOverlay;
